<template lang="pug">
  .store-locator-wrap.fixed-width-tweak-upper
    .store-locator.xs-12
      .lefty
        .form-wrapper.xs-12.mb-300m
          h1.xs-f-xxxlarge.md-f-xxgrande.upper.kapra-neue.max-at-tweak {{ title }}
          form.search-input-container.mt-5.mb-100m(name="GmapAutocomplete" @submit.prevent="setLocationBySubmit")
            GmvAutocomplete.search-input(
              ref="autocomplete"
              :value="autocompleteContent"
              @place_changed="onPlaceChanged"
              :options="{ componentRestrictions: { country: 'us' } }"
              :select-first-on-enter="true"
            )
            button.mr-btn.xs-f-xsmall.max-at-tweak(name="search" @click="setLocationBySubmit") Search
          a.xs-f-xsmall.bold.underline.xs-12.xs-hide.sm-hide(@click.prevent="getCurrentPosition") Use my current location
        LocationList(v-if="!isMobile" @tab-click="handleTabClick" @card-click="handleCardClick" :active-marker="selectedMarker" :mr-tab-active="mrTabActive" :mr-locations="mrLocations" :retail-locations="retailLocations" :icons="iconsObject")
      .righty.mb-200m
        .map-wrapper.xs-12
          .map-container(:class="{ sticky: locationList && locationList.length }")
            #map.native-map(v-if="mounted" :style="mapDimensions")
      .mobile-end
        LocationList(v-if="isMobile" @tab-click="handleTabClick" @card-click="handleCardClick" :active-marker="selectedMarker" :mr-tab-active="mrTabActive" :mr-locations="mrLocations" :retail-locations="retailLocations" :icons="iconsObject")
    
</template>
<script>
  import { utilities } from '@gmap-vue/v3';
  import vueColorbarSvc from '@services/vueColorbarSvc';
  import LocationList from './LocationList';
  import { mapState, mapActions } from 'vuex';
  import { toRaw } from "vue";
  import { MarkerClusterer } from "@googlemaps/markerclusterer";


  const { getGoogleMapsAPI, googleMapsApiInitializer } = utilities;

  const UNITED_STATES_CENTER = {
    lat: 39.8097343,
    lng: -98.5556199,
  };

  const DEFAULT_ZOOM_LEVEL = 3;

  const MAX_MARKERS_DISTANCE_FROM_CENTER_IN_MILES = 60;

  export default {
    name: "StoreLocator",

    components: {
      LocationList,
    },

    props: {
      nearbyLocationsMaxDistance: {
        type: Number,
        default: MAX_MARKERS_DISTANCE_FROM_CENTER_IN_MILES,
      },
      title: {
        type: String,
        default: "Find a store"
      },
      mrIcon: {
        type: Object,
        default: () => ({})
      },
      wallmartIcon: {
        type: Object,
        default: () => ({})
      },
      ultaIcon: {
        type: Object,
        default: () => ({})
      },
      whiteIcon: {
        type: Object,
        default: () => ({})
      },
    },

    data() {
      return {
        autocompleteContent: '',
        selectedMarker: null,
        center: UNITED_STATES_CENTER,
        zoom: DEFAULT_ZOOM_LEVEL,
        currentPlace: null,
        myDate: "pepe",
        mrTabActive: true,
        mrLocations: [],
        retailLocations: [],
        markers: [],
        map: null,
        nativeMarkers: [],
        markerCluster: null,
        currentPlaceMarker: null,
        mounted: false,

      };
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('customer', ['cdata']),
      gmapApi: getGoogleMapsAPI,

      isMobile() {
        return this.windowData.breakpoint === 'mobile';
      },

      locationList() {
        return this.mrTabActive ? this.mrLocations : this.retailLocations;
      },

      mapDimensions() {
        if (!this.isMobile) {
          return {
            width: '100%',
            height: '550px',
          };
        }

        return {
          width: '100%',
          height: '270px'
        };
      },

      iconsObject() {
        return {
          mrIcon: this.mrIcon?.url,
          ultaIcon: this.ultaIcon?.url,
          wallmartIcon: this.wallmartIcon?.url,
          whiteIcon: this.whiteIcon?.url
        };
      }

    },

    watch: {
      async locationList() {
        this.adjustZoom();
        
        await this.createMarkersWithCluster();
      },
    },

    async created() {
      let config = this.$root.MRConfig || {};
      googleMapsApiInitializer({
        key: config.googleAutocomplete,
        libraries: 'places,geometry',
        v: "weekly",
      });
    },

    async mounted() {
      await this.$gmapApiPromiseLazy();

      this.mounted = true;
      
      await this.$nextTick();
      
      await this.initNativeMap();

      this.getLocationFromCustomerData();
      this.getLocationList();
    },

    beforeUnmount() {
      this.clearMarkers();
    },

    methods: {
      ...mapActions(['notifyError']),

      async initNativeMap() {
        const mapElement = document.getElementById("map");
        if (!mapElement) {
          return;
        }

        const { Map } = await this.gmapApi.maps.importLibrary("maps");
        this.map = new Map(mapElement, {
          zoom: this.zoom,
          center: this.center,
          mapId: "e54caf4b0aa248c184cb905c",
          disableDefaultUI: true,
          zoomControl: true,
          fullscreenControl: true,
          minZoom: 3,
          maxZoom: 14,
        });
      },

      clearMarkers() {
        if (this.markerCluster) {
          this.markerCluster.clearMarkers();
          this.markerCluster = null;
        }

        this.nativeMarkers.forEach(marker => {
          marker.map = null;
        });
        this.nativeMarkers = [];
        if (this.currentPlaceMarker) {
          this.currentPlaceMarker.map = null;
          this.currentPlaceMarker = null;
        }
      },

      async createMarkersWithCluster() {
        if (!this.map || !this.locationList.length) {
          return;
        }

        const rawMap = toRaw(this.map);

        this.clearMarkers();

        const { AdvancedMarkerElement } = await this.gmapApi.maps.importLibrary("marker");

        this.nativeMarkers = this.locationList.map((location) => {
          const marker = new AdvancedMarkerElement({
            title: location.name,
            position: location.position,
            content: this.iconConfig(),
            map: rawMap,
          });

          marker.addListener("click", () => {
            this.handleNativeMarkerClick(location);
          });
          marker.location = location;

          return marker;
        });

        if (this.nativeMarkers.length > 0) {
          this.markerCluster = new MarkerClusterer({ 
            markers: this.nativeMarkers, 
            map: rawMap,
            onClusterClick: this.handleClusterClick,
          });
        }

        if (this.currentPlace) {

          this.currentPlaceMarker = new AdvancedMarkerElement({
            position: this.currentPlace.position,
            map: rawMap,
          });
        }
      },

      handleNativeMarkerClick(location) {
        this.trackEvent(`Map Marker Clicked`, { location });
        
        this.selectedMarker = { 
          location, 
          options: { position: location.position } 
        };

        this.map.panTo(location.position);
        this.map.setZoom(13);

        setTimeout(() => {
          const activeCard = document.querySelector('.locationCard.active');
          if (activeCard) {
            activeCard.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
      },

      iconConfig() {
        const width = 20;
        const glyphImg = document.createElement('img');
        glyphImg.src = new URL('https://media.madison-reed.com/d3ewrnwdcmri66.cloudfront.net/content/images/2022/2/l1cm1wy8-map-marker-2/map-marker-2.png').href;

        glyphImg.style.width = `${width}px`;
        glyphImg.style.height = `${width * 1.25}px`;

        return glyphImg;
      },

      handleClusterClick(ev, cluster) {
        const bounds = new this.gmapApi.maps.LatLngBounds();

        cluster.markers.forEach((marker) => {
          bounds.extend(marker.position);
        });

        this.map.fitBounds(bounds);
      },

      handleTabClick(value) {
        if (value) {
          this.trackMREvent("Store Locator - Mr tab clicked");
        } else {
          this.trackMREvent("Store Locator - Retailers tab clicked");
        }
        this.mrTabActive = value;
      },

      handleCardClick(loc) {
        this.selectedMarker = { location: loc, options: { position: loc.position } };

        const bounds = new this.gmapApi.maps.LatLngBounds();
        bounds.extend(loc.position);
        this.map.fitBounds(bounds);
        this.map.panTo(loc.position);
        this.map.setZoom(13);
      },

      getMarkerIcon(marker) {
        const isActiveMarker = marker?.location?.name === this.selectedMarker?.location?.name;
        let iconUrl = this.whiteIcon.url;
        const markerType = marker.location?.type;

        if (markerType === "MR") {
          iconUrl = this.mrIcon.url;
        } else if (markerType === "ULTA") {
          iconUrl = this.ultaIcon.url;
        } else if (markerType === "WALMART") {
          iconUrl = this.wallmartIcon.url;
        }

        const width = isActiveMarker ? 35 : 20;
        return {
          url: iconUrl,
          scaledSize: {
            width,
            height: Math.round(width * 1.25)
          }
        };
      },

      async getLocationList() {
        if (!this.currentPlace?.position) {
          return;
        }
        const data = (await vueColorbarSvc.getActiveWholesalesLocationsList({
          lat: this.currentPlace.position.lat,
          lon: this.currentPlace.position.lng,
          maxDistance: this.nearbyLocationsMaxDistance
        })).data;

        const mrLocations = [];
        const retailLocations = [];

        data.forEach(loc => {
          loc.position = {
            lat: loc.lat,
            lng: loc.lon
          };

          if (loc.type === 'MR') {
            mrLocations.push(loc);
          } else {
            retailLocations.push(loc);
          }
        });

        this.mrLocations = mrLocations;
        this.retailLocations = retailLocations;
      },

      handleMarkerClicked(marker) {
        this.trackEvent(`Map Marked Clicked`, { marker });
        this.selectedMarker = marker;
        this.$refs.map.map.panTo(marker.position);
        this.zoom = 13;
        setTimeout(() => {
          document.querySelector('.locationCard.active').scrollIntoView({ behavior: "smooth", block: "center" });
        }, 100);
      },

      onPlaceChanged(place) {
        this.trackEvent('Search Place Input Changed', { place });
        this.setCurrentPlace(place);
      },

      async setLocationBySubmit() {
        const el = this.$refs.autocomplete.$el.querySelector('input');
        const keyboardEvent = new KeyboardEvent('keydown', {
          code: 'Enter',
          key: 'Enter',
          charCode: 13,
          keyCode: 13,
          view: window,
          bubbles: true
        });

        el.dispatchEvent(keyboardEvent);
      },

      async getLocationFromCustomerData() {
        if (!this.gmapApi) {
          return;
        }

        if (!this.cdata) {
          return;
        }

        const { locationContext, address } = this.cdata;

        let filter;

        if (address && address.city && address.street_1) {
          const { city, country, post_code, street_1, street_2 } = address;
          filter = {
            address: `${street_1} ${street_2}, ${city} ${country} ${post_code}`,
          };
        } else if (locationContext) {
          const { latitude, longitude } = locationContext;
          if (!latitude || !longitude) {
            return;
          }
          filter = {
            location: {
              lat: latitude,
              lng: longitude,
            },
          };
        }

        if (!filter) {
          return;
        }

        try {
          const { Geocoder } = await this.gmapApi.maps.importLibrary("geocoding");
          const geocoder = new Geocoder();
          const { results } = await geocoder.geocode(filter);
          const [location] = results;
          if (location) {
            this.setCurrentPlace(location);
          }
        } catch (err) {
          this.notifyError({ err, silent: true });
        }
      },

      async setCurrentPlace(place) {
        if (!place) {
          return;
        }

        this.selectedMarker = null;

        if (place.geometry) {
          place.position = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
        }

        this.currentPlace = place;

        if (place.formatted_address) {
          this.autocompleteContent = place.formatted_address;
        }

        await this.getLocationList();
      },

      adjustZoom() {
        if (!this.map) {
          return;
        }

        if (this.locationList && this.locationList.length && this.currentPlace) {
          const bounds = new this.gmapApi.maps.LatLngBounds();
          this.locationList.forEach(({ position }) => {
            bounds.extend(position);
          });
          bounds.extend(this.currentPlace.position);
          this.map.fitBounds(bounds);
        } else {
          this.map.setCenter(UNITED_STATES_CENTER);
          this.map.setZoom(DEFAULT_ZOOM_LEVEL);
        }
      },

      getCurrentPosition() {
        if (!this.gmapApi) {
          return;
        }

        this.trackEvent(`Use My Location CTA Clicked`);
        this.loadingUserGeoLocation = true;
        navigator.geolocation.getCurrentPosition((currentPosition) => {
          const { coords: { latitude, longitude } } = currentPosition;
          this.loadingUserGeoLocation = false;
          this.autocompleteContent = '';

          const position = {
            lat: latitude,
            lng: longitude,
          };

          const geocoder = new this.gmapApi.maps.Geocoder();
          geocoder
            .geocode({ location: position })
            .then((response) => {
              const location = {
                ...response.results[0],
                position,
              };
              this.setCurrentPlace(location);
            }).catch(() => {
              this.setCurrentPlace({
                position,
              });
            });

        }, (error) => {
          this.loadingUserGeoLocation = false;
          if (error.code === 1) {
            this.notifyError('You must share your location first.');
          }
        });
      },
    },
  };

</script>
<style lang="stylus">
.search-input
  width 100%
  margin 0 !important
  flex 1
  height 44px
  font-size 16px
  padding 10px
  margin 0.55em 0
  border-radius 4px
  border 1px solid ui-color-6
</style>
<style scoped lang="stylus">
  .native-map
    width 100%
    height 100%

  .store-locator
    display grid
    grid-template-columns 3fr 4fr
    column-gap 4em
    padding 5em 1em 1em
    box-sizing border-box

    .form-wrapper
      display flex
      flex-direction column
      grid-column 1
      .search-input-container
        width 100%
        display flex
        flex-direction row
        position relative
        gap 1em

        div
          width 75%

        button.mr-btn
          padding 0.5em 2em

    .map-wrapper
      position sticky
      top 10px

  @media mq-tablet-less
    .store-locator
      grid-template-columns 1fr
      padding 1em
</style>
